import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* addGroupUsers({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.addUsers, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.addGroupUsersDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.addGroupUsersFailed,
      handledErrors,
      endpoint: api.modifiers.regularusers.addUsers.url
    });
  }
}

export const addGroupUsersSaga = takeEvery(types.ADD_GROUP_USERS_REQUEST, addGroupUsers);